import * as React from "react"
import { createRoot } from "react-dom/client"

import App from "./App"
import "./index.css"

import { AuthProvider } from "@/hooks/useAuth"

// ------------------------------------
// Service Worker control (UNCHANGED)
// ------------------------------------
const enableSW = import.meta.env.VITE_ENABLE_SW === "true"

if (enableSW && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(console.error)
} else if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister())
  })
}

// ------------------------------------
// App Bootstrap (NO Router here)
// ------------------------------------
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
)